import * as React from "react";
import { FieldSchema, FormControlDependsOnThenEnum, IInputFieldProps } from "@generation/core";
import { useFormContext } from "react-hook-form";
import { useDependsOnHook } from "./useDependsOnHook";

export function withValueSetHoc<T extends IInputFieldProps<FieldSchema>>(
  Component: React.FunctionComponent<T>
) {
  const component = (props: T) => {
    const { setValue } = useFormContext();

    const formFieldName = props.name.substring(0, props.name.lastIndexOf(".")) ?? "";
    const result = useDependsOnHook(formFieldName, props.field.dependsOn, [
      FormControlDependsOnThenEnum.SetValue
    ]);

    React.useEffect(() => {
      if (result?.setValue?.result) {
        setValue(props.name, result.setValue.value);
      }
    }, [result?.setValue?.value, result?.setValue?.result]);

    return <Component {...props} />;
  };

  component.displayName = "WithValueSetHoc";

  return component;
}
